import React from "react";
import PropTypes from "prop-types";
import { Alert, Table } from "antd";
import AlertFailedLoading from "../../AlertFailedLoading";
import SpinPageContent from "../../SpinPageContent";

function ReportTableDisplayResults({ data, loading, error, columns, setFilteredRows }) {
  if (loading && !data) {
    return <SpinPageContent />;
  }

  if (error) {
    return (
      <div style={{ padding: 24 }}>
        <AlertFailedLoading message="Report data failed to load" />
      </div>
    );
  }

  if (!data) {
    return (
      <div style={{ padding: 24 }}>
        <Alert
          message="Build a report"
          description={
            <span>
              Build a report and click <strong>Generate Report</strong> to view the data for that report.
            </span>
          }
          type="info"
          showIcon
        />
      </div>
    );
  }

  // Utilising the generic AntD v3 Table library. See docs website for API details.
  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={loading}
      pagination={{
        showSizeChanger: true,
        defaultPageSize: 50,
        pageSizeOptions: ["50", "100", "500", "1000"],
      }}
      onChange={(_pagination, _filters, _sorter, extra) => setFilteredRows(extra.currentDataSource)}
    />
  );
}

ReportTableDisplayResults.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  setFilteredRows: PropTypes.func.isRequired,
};

ReportTableDisplayResults.defaultProps = {
  data: null,
  error: null,
};

export default ReportTableDisplayResults;
